import React from 'react'
import classNames from 'classnames'
// empty.module.scss
import headerStyle from './empty.module.scss'

type Style = {
  // 组件包裹层的额外样式
  style?: React.CSSProperties
  // 图片的额外样式
  imgStyle?: React.CSSProperties
  // 文字的额外样式
  textStyle?: React.CSSProperties
}

export type EmptyProps =  {
  // 图片地址
  imgUrl?: string
  // 说明
  desc?: string
  // 主题
  theme?: 'dark' | 'light' | 'darkBlue' | 'ipMachine'
} & Style

const defaultEmpty = {
  desc: '暂无数据',
  theme: 'light',
}

const Empty = (props: EmptyProps) => {

  const {
    imgUrl,
    desc = defaultEmpty.desc,
    theme = defaultEmpty.theme,
    style,
    imgStyle,
    textStyle,
  } = props

  const wrapClassName = classNames(
    headerStyle.wrap,
    `${headerStyle[theme]}`
  )

  return <div className={wrapClassName}
      style={style}>
      <div className={headerStyle.pic}
          style={{backgroundImage: imgUrl, ...imgStyle}}></div>
      <div className={headerStyle.desc}
          style={textStyle}>{desc}</div>
    </div>
}

export default Empty